<template>
  <div
    class="top-img"
    :style="{ backgroundImage: 'url(' + getImageUrl(image) + ')' }"
  >
    <div class="fade-img"></div>
  </div>
</template>

<script>
export default {
  props: {
    image: String,
  },
  methods: {
    getImageUrl(image) {
      return require("./../../assets/images/" + image);
    },
  },
};
</script>

<style lang="scss">
.top-img {
  height: 700px;
  background-size: cover;
  margin-top: 0px;
  background-position: center bottom;
}
.fade-img {
  background-image: url(./../../assets/images/fade.png);
  height: 300px;
  background-repeat: repeat;
  z-index: 2;
}
</style>
